module.exports = __webpack_public_path__ + "static/delivery200-98a3f02aacf4f4f6e32138e105134cb3.png";